const IP_API_URL = 'https://ipapi.co/json/';
const IP_CACHE_KEY = 'chill_tree_guest_ip';
const IP_CACHE_TIMESTAMP_KEY = 'chill_tree_guest_ip_timestamp';
const IP_CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

class GuestIdentifierService {
  async getIdentifier() {
    // 1. Try to get a valid IP from cache
    const cachedIp = localStorage.getItem(IP_CACHE_KEY);
    const cachedTimestamp = localStorage.getItem(IP_CACHE_TIMESTAMP_KEY);

    if (cachedIp && cachedTimestamp) {
      const timestamp = parseInt(cachedTimestamp, 10);
      const age = Date.now() - timestamp;
      if (age < IP_CACHE_DURATION) {
        return cachedIp;
      }
    }

    // 2. If no valid cache, fetch from API
    try {
      const response = await fetch(IP_API_URL);
      if (!response.ok) {
        throw new Error(`IP API failed with status: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.ip) {
        localStorage.setItem(IP_CACHE_KEY, data.ip);
        localStorage.setItem(IP_CACHE_TIMESTAMP_KEY, Date.now().toString());
        return data.ip;
      }
      throw new Error('IP address not found in API response');
    } catch (error) {
      console.error('Failed to fetch IP address:', error);
      return cachedIp || ''; // Return last known IP or empty
    }
  }
}

const guestIdentifierService = new GuestIdentifierService();
export default guestIdentifierService;
